import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';
import { ReviewedTeam, SearchTeam, TeamWithCurrency } from '../classes/SearchTeam';
import { changeDate } from 'src/app/shared/functions/convert-date-to-unix';

@Injectable({
  providedIn: 'root'
})
export class AccreditationRequestDetailsService {

  refreshDetails = new BehaviorSubject<boolean>(false);
  requestDetails = new BehaviorSubject<any>(null);
  requestToken = new BehaviorSubject<string>(null);
  teamToken = new BehaviorSubject<string>(null);
  paymentToken = new BehaviorSubject<string>(null);
  manDays = new BehaviorSubject<any>(null);
  requestCurrency = new BehaviorSubject<any>(null);
  cabRequestPreVisit = new BehaviorSubject<any>(null);
  disablePlanCalenderDays = new BehaviorSubject<any>(null);
  is_healthcare_schem = new BehaviorSubject<any>(false);

  formSelectedTeam = new BehaviorSubject<SearchTeam[]>([]);
  formReviewedTeam = new BehaviorSubject<ReviewedTeam[]>([]);
  suggestRepresentativeTeam = new BehaviorSubject<ReviewedTeam[]>([]);
  formCommitteeData = new BehaviorSubject<any>(null);
  teamWithCurrency = new BehaviorSubject<TeamWithCurrency[]>([]);
  formRecommindation = new BehaviorSubject<any>(null);
  formCommitteeConvener = new BehaviorSubject<any>(null);

  addNewRequest = new BehaviorSubject<boolean>(false);
  renewRequest = new BehaviorSubject<boolean>(false);
  extendRequest = new BehaviorSubject<boolean>(false);
  editRequest = new BehaviorSubject<boolean>(false);
  requestType = new BehaviorSubject<any>(null);
  schemaHave_SUA = new BehaviorSubject<boolean>(false);
  approveAgreement = new BehaviorSubject<boolean>(false);
  userHaveUEA_Nationality = new BehaviorSubject<boolean>(false);
  LastScopesSelectedForRenew_Extend = new BehaviorSubject<any>([]);
  selectedAbToken = new BehaviorSubject<any>('');

  choosenCabToken = new BehaviorSubject<any>(null);
  aggrementFileUploaded = new BehaviorSubject<any>(null);

  constructor(private apiService: ApiService) { }

  getRequestDetails(token) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_details`, token)
      .pipe(catchError(this.handleError));
  }
  checkCabAccreditationSchema(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/check_cab_accreditation_schema`, model)
      .pipe(catchError(this.handleError));
  }

  checkCabAccreditationNumber(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/check_cab_accreditation_number`, model)
      .pipe(catchError(this.handleError));
  }

  getRequestTimeline(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_timeline`, filter)
      .pipe(catchError(this.handleError));
  }
  getDigitalSignature(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_cab_request_agreements`, filter)
      .pipe(catchError(this.handleError));
  }
  getSignaturesFile(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/download_signatures_file`, model)
      .pipe(catchError(this.handleError));
  }
  dynamicAction(model, attachments = null) {
    let data;
    if (attachments) {
      const formData = new FormData();
      if (attachments && attachments.length) {
        attachments.forEach(file => {
          formData.append(model.multiAttached ? 'attached_file[]' : 'attached_file', file, file.name);
          formData.append(model.multiAttached ? 'attachments[]' : 'attachments', file, file.name);
        });
      }
      for (const prop in model) {
        if (model.hasOwnProperty(prop) && prop !== 'endPoint') {
          // formData.append(prop, String(model[prop]));
          if (model[prop] instanceof Array) {
            model[prop].forEach((item: any, index: number) => {
              if (item instanceof File) {
                formData.append(`${prop}[]`, item, item.name);
              } else if (item instanceof Object) {
                for (const key in item) {
                  formData.append(`${prop}[${index}][${key}]`, item[key]);
                }
              }
              else {
                formData.append(`${prop}[]`, item);
              }
            });
          } else if (model[prop] instanceof Date) {
            formData.append(prop, String(changeDate(model[prop], 0)))
          } else {
            formData.append(prop, String(model[prop]));
          }
        }
      }
      data = formData;
    } else {
      data = model;
    }
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + model.endPoint, data)
      .pipe(catchError(this.handleError));
  }
  acceptRequest(model) {
    // const formData = new FormData();
    // if (enCertificateFile.length) {
    //   formData.append('certificate_file', enCertificateFile[0], enCertificateFile[0].name);
    // }
    // if (arCertificateFile.length) {
    //   formData.append('certificate_ar_file', arCertificateFile[0], arCertificateFile[0].name);
    // }
    // if (scopesFile.length) {
    //   formData.append('scopes_file', scopesFile[0], scopesFile[0].name);
    // }
    // for (const prop in model) {
    //   if (model.hasOwnProperty(prop) && prop !== 'endPoint') {
    //     if (prop === 'token_scopes') {
    //       formData.append(prop + '[]', model[prop]);
    //     } else {
    //       formData.append(prop, model[prop]);
    //     }
    //   }
    // }
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + model.endPoint, model)
      .pipe(catchError(this.handleError));
  }

  viewCertificate(model) {
    return this.apiService
      .getDownload(`${environment.apiUrl}/api/system/cab/` + model.endPoint, model)
      .pipe(catchError(this.handleError));
  }

  getRequestScopes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_all_request_scopes`, model)
      .pipe(catchError(this.handleError));
  }
  searchManagers(endPoint, model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + endPoint, model)
      .pipe(catchError(this.handleError));
  }
  getDocumentDetails(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_documents_attachments`, filter)
      .pipe(catchError(this.handleError));
  }
  getDocumentDetailsForEdit(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_documents_attachments_for_edit`, filter)
      .pipe(catchError(this.handleError));
  }
  addRequestDocuments(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_document_request`, data)
      .pipe(catchError(this.handleError));
  }
  getScopesDetails(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_details_scopes`, filter)
      .pipe(catchError(this.handleError));
  }
  getrequestDetailsTab(data) {
    // get_request_main_details
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_main_details`, data)
      .pipe(catchError(this.handleError));
  }
  getFileManagerRecommendations(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_file_manager_recommendation`, data)
      .pipe(catchError(this.handleError));
  }
  getPaymentDetailsTab(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_payments`, data)
      .pipe(catchError(this.handleError));
  }
  getRequestDetailsContract(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_contract`, data)
      .pipe(catchError(this.handleError));
  }
  editContractAgreement(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_contract_agreement`, data)
      .pipe(catchError(this.handleError));
  }
  getContractTemplate(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_contract_agreement`, model)
      .pipe(catchError(this.handleError));
  }
  // document review tab
  // getDocumentReview(data) {
  //   return this.apiService
  //   .post(`${environment.apiUrl}/api/system/cab/document_review_team`, data)
  //   .pipe(catchError(this.handleError));
  // }
  getsingleTeamView(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_single_team_view`, data)
      .pipe(catchError(this.handleError));
  }
  getsingleTeamView_withoutTeamLead(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_team_members_data`, data)
      .pipe(catchError(this.handleError));
  }
  // getConfidentialityAgreements(data) {
  //   return this.apiService
  //   .post(`${environment.apiUrl}/api/system/cab/document_review_team_confidentiality_agreement`, data)
  //   .pipe(catchError(this.handleError));
  // }
  getEvidences(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/document_review_team_evidences`, data)
      .pipe(catchError(this.handleError));
  }
  getCheckListTopics(data, endpoint = 'get_request_checklist') {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/${endpoint}`, data)
      .pipe(catchError(this.handleError));
  }
  getCheckListTopics_SubSections(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_checklist_questions`, data)
      .pipe(catchError(this.handleError));
  }

  getCheckListTopics_SubSections_witness_report(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/assessment_visit_team_witness_report_heading`, data)
      .pipe(catchError(this.handleError));
  }

  getVisitTeamMembers(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_list_meeting_members`, data)
      .pipe(catchError(this.handleError));
  }

  saveCabAnwesersAsDraft(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_request_checklist_questions`, data)
      .pipe(catchError(this.handleError));
  }

  saveAssessourNotes(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_checklist_assessour_notes`, data)
      .pipe(catchError(this.handleError));
  }

  saveCabReplies(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_checklist_cab_replies`, data)
      .pipe(catchError(this.handleError));
  }

  getReports(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/document_review_team_reports`, data)
      .pipe(catchError(this.handleError));
  }
  // forwardDetailsToDrTeam(model, attachments = null) {
  //   const formData = new FormData();
  //   if (attachments && attachments.length) {
  //     attachments.forEach(file => {
  //       formData.append('files_doc[]', file, file.name);
  //     });
  //   }

  //   // formData.append('data', JSON.stringify(model));
  //   for (const prop in model) {
  //     if (model.hasOwnProperty(prop) && prop !== 'endPoint') {
  //       if (prop === 'attachment_documents') {
  //         model.attachment_documents.forEach(doc => {
  //           formData.append('attachment_type[]', doc.attachment_type);
  //           doc.files.forEach((file, j) => {
  //             formData.append('attachment_documents[' + j + '][document_token]', file.document_token);
  //             file.document_viewers_tokens.forEach(memberToken => {
  //               formData.append('attachment_documents[' + j + '][document_viewers_tokens][]', memberToken);
  //             });
  //           });
  //         });
  //       } else {
  //         formData.append(prop, model[prop]);
  //       }
  //     }
  //   }
  //   return this.apiService
  //     .post(`${environment.apiUrl}/api/system/cab/` + model.endPoint, formData)
  //     .pipe(catchError(this.handleError));
  // }

  forwardDetailsToDrTeam(model, attachments = null) {
    // const formData = new FormData();
    // if (attachments && attachments.length) {
    //   attachments.forEach(file => {
    //     formData.append('files_doc[]', file, file.name);
    //   });
    // }
    // for (const key in model) {
    //   const element = model[key];
    //   formData.append(key, element);
    // }
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + model.endPoint, model)
      .pipe(catchError(this.handleError));
  }

  searchTeam(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/search_suggest_team`, filter)
      .pipe(catchError(this.handleError));
  }
  modifySuggestTeam(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/modify_suggest_team`, filter)
      .pipe(catchError(this.handleError));
  }
  searchConvener(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/search_users_convener_for_cab`, filter)
      .pipe(catchError(this.handleError));
  }
  searchCommittee(filter, IsAdvisoryCommittee = false) {
    if (IsAdvisoryCommittee) {
      // search_advisory_committee
      return this.apiService
        .post(`${environment.apiUrl}/api/system/cab/search_advisory_committee`, filter)
        .pipe(catchError(this.handleError));
    } else {
      // search_create_committee
      return this.apiService
        .post(`${environment.apiUrl}/api/system/cab/search_technical_committee`, filter)
        .pipe(catchError(this.handleError));
    }

  }
  listAllCommittees(filter) {
    let endPoint: any;
    switch (filter.endPoint) {
      case 'ed_create_appealing_committee':
        endPoint = 'list_all_appealing_committees'
        break;
      case 'ed_create_advisory_committee':
        endPoint = 'list_all_committees'
        break;
      case 'ed_create_technical_committee':
        endPoint = 'list_all_technical_committees'
        break;
      default:
        break;
    }
    // const endPoint = filter.endPoint === 'ed_create_appealing_committee' ? 'list_all_appealing_committees' : 'list_all_technical_committees';
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/${endPoint}`, filter)
      .pipe(catchError(this.handleError));
  }

  handleError(error) {
    return throwError(error);
  }


  // common (document review tab, pre Assessment Visit) //---------

  // getTeamMembers(data, endPoint) {
  //   return this.apiService
  //     .post(`${environment.apiUrl}/api/system/cab/` + endPoint, data)
  //     .pipe(catchError(this.handleError));
  // }
  // getAsseesmentConfidentialityAgreements(data, endPoint) {
  //   return this.apiService
  //     .post(`${environment.apiUrl}/api/system/cab/` + endPoint, data)
  //     .pipe(catchError(this.handleError));
  // }

  addNoteOnSubSectionVisit(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_general_comments`, model)
      .pipe(catchError(this.handleError));
  }
  getDiscussions(data, endPoint) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + endPoint, data)
      .pipe(catchError(this.handleError));
  }
  sendDiscussionData(data, attachments) {
    const formData = new FormData();
    if (attachments && attachments.length) {
      attachments.forEach(file => {
        formData.append('attachments[]', file, file.name);
      });
    }

    for (const prop in data) {
      if (data.hasOwnProperty(prop)) {
        let values = data[prop];
        if (prop === 'notes') { values = JSON.stringify(data[prop]); }
        formData.append(prop, values);
      }
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/team_member_add_comment`, formData)
      .pipe(catchError(this.handleError));
  }

  sendDataDynamiclly(data, attachments) {
    const formData = new FormData();
    if (attachments && attachments.length) {
      attachments.forEach(file => {
        formData.append('attachments[]', file, file.name);
      });
    }

    for (const prop in data) {
      if (data.hasOwnProperty(prop)) {
        let values = data[prop];
        if (prop === 'notes') { values = JSON.stringify(data[prop]); }
        formData.append(prop, values);
      }
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/team_member_add_requirements`, formData)
      .pipe(catchError(this.handleError));
  }

  generalGetData(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/${data.endPoint}`, data)
      .pipe(catchError(this.handleError));
  }

  deleteQutaion(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cm_delete_payment_item`, data)
      .pipe(catchError(this.handleError));
  }

  getCurrencyList(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_currency_list`, data)
      .pipe(catchError(this.handleError));
  }
  changeRequestCurrency(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cm_change_request_currency `, data)  //replace existing "change_request_currency"
      .pipe(catchError(this.handleError));
  }
  addPaymentOrders(data: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cm_add_payment_order`, data) //replace existing "ad_add_payment_order"
      .pipe(catchError(this.handleError));
  }
  updatePaymentOrder(data: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cm_edit_payment_item`, data) //replace existing "edit_payment_item"
      .pipe(catchError(this.handleError));
  }
  // downloadAttachments(filePath) {
  //   return this.apiService.get(
  //     `${environment.apiUrl}/api/system/cab/download_attachments_request?att=${filePath}`
  //   );
  // }

  downloadFile(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/cab/download_attachments_request`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  uploadReportsFileVisit(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/report_files_visit`, data)
      .pipe(catchError(this.handleError));
  }
  closeReportTeam(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/close_report_team`, data)
      .pipe(catchError(this.handleError));
  }
  replayReportTeam(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/replay_from_cab`, data)
      .pipe(catchError(this.handleError));
  }

  digitalSignatureConfrim(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/digital_signature_callback`, filter)
      .pipe(catchError(this.handleError));
  }

  getTechniques(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_techniques`, filter)
      .pipe(catchError(this.handleError));
  }
  getSUA_Table(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_sua_popup`, filter)
      .pipe(catchError(this.handleError));
  }

  getSelectedPlanCluases(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_plan_clause_members`, filter)
      .pipe(catchError(this.handleError));
  }
  getSelectedVisitDates(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_team_selected_dates`, filter)
      .pipe(catchError(this.handleError));
  }


  getRequestChecklist_sub(filter) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_checklist_sub`, filter)
      .pipe(catchError(this.handleError));
  }

  AddMeeting(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_meeting`, model)
      .pipe(catchError(this.handleError));
  }

  editMeeting(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_team_meeting`, model)
      .pipe(catchError(this.handleError));
  }

  deleteMeeting(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_team_meeting`, model)
      .pipe(catchError(this.handleError));
  }
  manageAssessorMeeting(model, editMode: boolean = false) {
    if (editMode) {
      // not emplemented yet
    } else {
      return this.apiService
        .post(`${environment.apiUrl}/api/system/cab/add_assessor_meeting`, model)
        .pipe(catchError(this.handleError));
    }
  }

  getAssessorsForMeeting(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_assessor_meeting_members`, model)
      .pipe(catchError(this.handleError));
  }

  NotifyAssessorFindingsToEntity(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/notify_assessor_findings_to_entity`, model)
      .pipe(catchError(this.handleError));
  }

  SendFindingsToEntity(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/send_findings_to_entity`, model)
      .pipe(catchError(this.handleError));
  }

  getQuestionsByHeadingId(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/team_visit_reports_sub`, model)
      .pipe(catchError(this.handleError));
  }

  dynamicActionWithArraies(model: any, haveAttachments = false) {

    let data;
    if (haveAttachments) {
      // delete model.endPoint;
      const formData: FormData = this.buildFormData(model);
      // for (const key in model) {
      //   if (model.hasOwnProperty(key) && key !== 'endPoint') {
      //     if (model[key] instanceof Array) {
      //       model[key].forEach((item: any, index: number) => {
      //         if (item instanceof File) {
      //           formData.append(`${key}[]`, item, item.name);
      //         } else if (item instanceof Object) {
      //           for (const key2 in item) {
      //             formData.append(`${key}[${index}][${key2}]`, item[key2]);
      //           }
      //         }
      //         else {
      //           formData.append(`${key}[]`, item);

      //         }
      //       });
      //     } else if (model[key] instanceof Date) {
      //       formData.append(key, String(changeDate(model[key], 0)))
      //     } else {
      //       formData.append(key, String(model[key]));
      //     }
      //   }
      // }
      data = formData;
      formData.forEach((value, key) => {
        console.log(key, value);
      })
      debugger;
      // return;
    } else {
      data = model;
    }
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + model.endPoint, data)
      .pipe(catchError(this.handleError));
  }


  buildFormData(data: any, formData: FormData = new FormData(), parentKey: string = ''): FormData {
    if (data === null || data === undefined) {
      return formData;
    }

    if (data instanceof File || data instanceof Blob) {
      formData.append(parentKey, data);
    } else if (data instanceof Date) {
      formData.append(parentKey, data.toISOString());
    } else if (Array.isArray(data)) {
      data.forEach((item, index) => {
        // Recursively handles nested arrays using index paths: parentKey[0]
        this.buildFormData(item, formData, `${parentKey}[${index}]`);
      });
    } else if (typeof data === 'object') {
      Object.keys(data).forEach((key) => {
        // Constructs key paths: parentKey[childKey] or root key
        const constructedKey = parentKey ? `${parentKey}[${key}]` : key;
        this.buildFormData(data[key], formData, constructedKey);
      });
    } else {
      formData.append(parentKey, String(data));
    }

    return formData;
  }

  AddSymbol(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_eiac_symbol`, model)
      .pipe(catchError(this.handleError));
  }

  editSymbol(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_team_eiac_symbol`, model)
      .pipe(catchError(this.handleError));
  }

  deleteSymbol(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_team_eiac_symbol`, model)
      .pipe(catchError(this.handleError));
  }


  getRecommendations(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_recommendation_list`, model)
      .pipe(catchError(this.handleError));
  }

  getSpecificScopes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_all_cab_scopes`, model)
      .pipe(catchError(this.handleError));
  }

  getSpecificSUA_Scopes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_sua_by_ab_token`, model)
      .pipe(catchError(this.handleError));
  }

  getReasons(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_acc_committee_reasons`, model)
      .pipe(catchError(this.handleError));
  }

  AddRecommendation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_recommendation`, model)
      .pipe(catchError(this.handleError));
  }

  editRecommendation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_team_recommendation`, model)
      .pipe(catchError(this.handleError));
  }

  deleteRecommendation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_team_recommendation`, model)
      .pipe(catchError(this.handleError));
  }


  // Comments sub-Tap

  AddComment(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_comments`, model)
      .pipe(catchError(this.handleError));
  }

  editComment(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_team_comments`, model)
      .pipe(catchError(this.handleError));
  }

  deleteComment(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_team_comments`, model)
      .pipe(catchError(this.handleError));
  }

  // Summary and Recommendations sub-tab

  AddSummery(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_team_pre_summary`, model)
      .pipe(catchError(this.handleError));
  }

  editSummery(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/edit_team_pre_summary`, model)
      .pipe(catchError(this.handleError));
  }

  deleteSummery(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_team_pre_summary`, model)
      .pipe(catchError(this.handleError));
  }

  getReasonsForScopesList() {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_suspension_reason_list`)
      .pipe(catchError(this.handleError));
  }
  getSuspendedScopes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_request_suspended_scopes`, model)
      .pipe(catchError(this.handleError));
  }

  saveWitnessReportAsDraft(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_request_witness_report`, data)
      .pipe(catchError(this.handleError));
  }

  RemoveSuggested(model: any, apiLink: string = 'remove_suggested_scopes') {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/${apiLink ? apiLink : 'remove_suggested_scopes'}`, model)
      .pipe(catchError(this.handleError));
  }

  getFullpathScope(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_full_path_scope`, model)
      .pipe(catchError(this.handleError));
  }
  saveSUA_VisitTable(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_visit_sua`, model)
      .pipe(catchError(this.handleError));
  }
  saveSUA_VisitRow(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_sua_item`, model)
      .pipe(catchError(this.handleError));
  }
  getProgramDetails(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_acc_program_details`, model)
      .pipe(catchError(this.handleError));
  }

  saveProgram(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/save_request_acc_program`, model)
      .pipe(catchError(this.handleError));
  }

  getMyCabs() {
    return this.apiService
      .get(`${environment.apiUrl}/api/system/cab/get_my_cabs`)
      .pipe(catchError(this.handleError));
  }

  getExportReportOptions(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/check_export_options`, model)
      .pipe(catchError(this.handleError));
  }

  ExportReport(model: any) {
    return this.apiService
      .getDownload(`${environment.apiUrl}/api/system/cab/generateReport`, model)
      .pipe(catchError(this.handleError));
  }

  saveDecision(data) {
    // Prepare FormData object
    const formData = new FormData();

    // Add primitive fields from data to FormData, skip 'attachments'
    Object.keys(data).forEach(key => {
      if (key !== 'attachments') {
        // null or undefined (e.g. decision_id for new record) should be omitted in FormData
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
    });

    // If attachments present, add each file/object with their type
    if (Array.isArray(data.attachments)) {
      data.attachments.forEach((attachment) => {
        // If it's a File or Blob, add to formData as file
        if (attachment instanceof File || attachment instanceof Blob) {
          formData.append('attachments[]', attachment);
        }
      });
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/${data.decision_id ? 'edit_final_decision' : 'add_final_decision'}`, formData)
      .pipe(catchError(this.handleError));
  }

  deleteDecision(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/delete_final_decision`, data)
      .pipe(catchError(this.handleError));
  }

  getMemberScopes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_assessor_details`, model)
      .pipe(catchError(this.handleError));
  }

  assignModifyTeam(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cm_assign_modify_team`, model)
      .pipe(catchError(this.handleError));
  }

  requestForVisitSUA(model: any) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/cab_request_visit_sua_for_witness`, model)
      .pipe(catchError(this.handleError));
  }

  addQuotationComment(data: any, attachments: any) {
    const formData = new FormData();
    if (attachments && attachments.length) {
      attachments.forEach(file => {
        formData.append('attachments[]', file, file.name);
      });
    }

    for (const prop in data) {
      if (data.hasOwnProperty(prop)) {
        let values = data[prop];
        if (prop === 'notes') { values = JSON.stringify(data[prop]); }
        formData.append(prop, values);
      }
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/add_qutation_decision`, formData)
      .pipe(catchError(this.handleError));
  }


}
